import { createElement, memo } from 'react';
import { useDesignTokens, DesignTokens, renderInlineCssVars } from '../../../theme';
import { setAlpha } from '../../../design-tokens/utils';
import { useIsRTL } from '../../../locale';
import { postfixTestId, TestIdProps } from '../../../util/testId';
import cn from './SliderTrackTicks.css.json';
import './SliderTrackTicks.css';
export interface SliderTrackTicksProps extends TestIdProps {
  tickPositions: number[];
  orientation: 'horizontal' | 'vertical';
}

export const SliderTrackTicks = memo(function SliderTrackTicks(props: SliderTrackTicksProps) {
  const dt = useDesignTokens();
  const isRTL = useIsRTL();

  const tickThemeTokens = renderInlineCssVars(getTickThemeTokens(dt), 'slider-track-ticks');

  return (
    <div data-testid={props.testId} className={cn.tickContainer[props.orientation]}>
      {props.orientation === 'vertical'
        ? props.tickPositions.map((tickPos, index) => {
            return (
              <div
                data-testid={postfixTestId(props.testId, `tick${index}`)}
                key={index}
                className={cn.tick[props.orientation]}
                style={{
                  ...tickThemeTokens,
                  top: `${(1 - tickPos) * 100}%`,
                }}
              />
            );
          })
        : props.tickPositions.map((tickPos, index) => {
            return (
              <div
                data-testid={postfixTestId(props.testId, `tick${index}`)}
                key={index}
                className={cn.tick[props.orientation]}
                style={{
                  ...tickThemeTokens,
                  right: isRTL ? `${tickPos * 100}%` : undefined,
                  left: !isRTL ? `${tickPos * 100}%` : undefined,
                }}
              />
            );
          })}
    </div>
  );
});

const getTickThemeTokens = (dt: DesignTokens) => {
  if (dt.enableNovaTokens) {
    return {
      fg: dt.c.colorUiBorder,
    };
  } else {
    switch (dt.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: dt.c.white,
        };
    }
    switch (dt.themeVariant) {
      case 'high-contrast':
        return {
          fg: dt.c.n2,
        };
      case 'dark':
        return {
          fg: setAlpha(dt.c.white, 0.3),
        };
      default:
        return {
          fg: dt.c.n_1,
        };
    }
  }
};
